import Paper from '@material-ui/core/Paper';
import ItemsAutoComplete from "../_customs/ItemsAutoComplete";
import {useDispatch} from "react-redux";
import {getItemById, searchFilterAll} from "../../redux/actions/item/ItemAction";


export default function ItemSearchBar() {
    const dispatch = useDispatch();

    const handleSearch = (result) => {
        if (result) dispatch(getItemById(result?.id))
        else dispatch(searchFilterAll())
    }


    return (
        <Paper style={{padding: 2, display: 'flex', height: 48}} elevation={5}>
            <ItemsAutoComplete style={{width: '100%'}} minWidth={'100%'} onChange={handleSearch}/>
        </Paper>
    )
}
